import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import { PaymentMethodAvailability } from '@ca/common'
import MethodInfoCard from './MethodInfoCard'

interface Props {
  open: boolean
  close: () => void
  availability: PaymentMethodAvailability[]
  hasSelection?: boolean
}

export default function PaymentMethodsInfoModal({
  open,
  close,
  availability,
  hasSelection = true,
}: Props) {
  const { t } = useTranslation(['modals'])

  return (
    <ModalBottom
      open={open}
      close={close}
      title={t('modals:checkout.paymentMethods.title')}
      desc={t('modals:checkout.paymentMethods.desc')}
      hideBottomSpace
      spacedText
      center
    >
      <View className="flex w-full flex-col gap-8 px-16 pb-16">
        {availability.map((method) => (
          <MethodInfoCard
            key={method.method}
            item={method}
            hasSelection={hasSelection}
          />
        ))}
      </View>
    </ModalBottom>
  )
}
